// extracted by mini-css-extract-plugin
export default {"text":"C9WDg8Gn3wlR8XgB6SdQ","number":"NFEOWPCiPGofzlcTPO1q"};